export const RECIPE_FORM_TABS = {
  NOTES: 'notes',
  REGULAR: 'regular',
};
